// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".techcast-english-footer{.cookieControl__BarButtons{@media (min-width:768px){right:147px!important}}.cookie-remove-modal{@media (min-width:768px){left:365px!important}}.cookie-remove-bar{@media (max-width:767px){bottom:2.5rem!important}}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
